import { useEffect, useState } from 'react'
import { Grid, Typography } from '@mui/material'

import { useNavigate } from 'react-router-dom'

import { BaseBox, PermissionsBox } from './components'

import { Link, MUI } from 'components'
import { getBaseURL, getTrayApplicationKey } from 'service/env'
import service from 'service'

const Install = () => {
  const [isLoading, setLoading] = useState<boolean>(false)
  const search = new URLSearchParams(location.search)
  const navigate = useNavigate()

  const storeUrl = search.get('url')
  const storeId = search.get('store')

  const consumerKey = getTrayApplicationKey()
  const callbackUrl = `${getBaseURL('web')}/tray/callback`

  useEffect(() => {
    const verifyStore = async () => {
      if (storeId) {
        setLoading(true)
        const response = await service.dponet.tray.verify(storeId)
        if (response?.data?.exists) {
          if (response?.data?.installed) {
            return navigate('/')
          }

          return handleInstall()
        }

        setLoading(false)
      }
    }

    verifyStore()
    //eslint-disable-next-line
  }, [])

  const handleInstall = () => {
    if (storeUrl) {
      setLoading(true)
      window.location.replace(
        `${storeUrl}/auth.php?response_type=code&consumer_key=${consumerKey}&callback=${callbackUrl}`
      )
      setTimeout(() => {
        setLoading(false)
      }, 2000)
    }
  }

  return (
    <BaseBox title="Ao instalar o aplicativo, iremos:">
      <Grid item xs={12}>
        <PermissionsBox />

        <MUI.Button
          onClick={handleInstall}
          variant="contained"
          color="success"
          disabled={isLoading}
        >
          Instalar
        </MUI.Button>
      </Grid>
      <Grid item xs={12}>
        <Typography>
          <Link onClick={() => window.close()} to="#">
            Cancelar
          </Link>
        </Typography>
      </Grid>
    </BaseBox>
  )
}

export default Install
